import * as React from "react"
export const IconCmmeCheckboxSelected = (props) => {
    const fill = props?.fill || '#202020';
    return <svg width="20" height="20" viewBox="5 5 20 20" fill={fill} xmlns="http://www.w3.org/2000/svg">
        <path d="m13.756 18.733 6.266-6.266-1.244-1.245-5.022 5.022-2.534-2.533-1.244 1.245 3.778 3.777zM8.778 23c-.49 0-.908-.174-1.256-.522A1.712 1.712 0 0 1 7 21.222V8.778c0-.49.174-.908.522-1.256A1.712 1.712 0 0 1 8.778 7h12.444c.49 0 .908.174 1.256.522.348.348.522.767.522 1.256v12.444c0 .49-.174.908-.522 1.256a1.712 1.712 0 0 1-1.256.522H8.778z" />
    </svg>
}
export default IconCmmeCheckboxSelected;